function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Contract-document2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "common-file-text-edit",
  transform: "translate(4.000000, 4.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.0020833,20.6854167 L20.875,31.8125 L15.40625,32.90625 L16.5,27.4375 L27.6270833,16.3104167 C28.2053813,15.7312075 28.9902687,15.4057345 29.80875,15.4057345 C30.6272313,15.4057345 31.4121187,15.7312075 31.9904167,16.3104167 L32.0020833,16.3220833 C32.5812925,16.9003813 32.9067655,17.6852687 32.9067655,18.50375 C32.9067655,19.3222313 32.5812925,20.1071187 32.0020833,20.6854167 L32.0020833,20.6854167 Z",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.46875,
  y1: 8.84375,
  x2: 18.46875,
  y2: 8.84375,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.46875,
  y1: 15.40625,
  x2: 18.46875,
  y2: 15.40625,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.46875,
  y1: 21.96875,
  x2: 12.46875,
  y2: 21.96875,
  id: "Path",
  stroke: "#425CD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.9375,28.53125 L2.28125,28.53125 C1.07312711,28.53125 0.09375,27.5518729 0.09375,26.34375 L0.09375,2.28125 C0.09375,1.07312711 1.07312711,0.09375 2.28125,0.09375 L17.781875,0.09375 C18.3616313,0.09375 18.9176273,0.324140055 19.3277083,0.733958333 L23.5160417,4.92229167 C23.9258599,5.33237265 24.15625,5.88836866 24.15625,6.468125 L24.15625,11.03125",
  id: "Path",
  stroke: "#485156"
})));
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Contract document2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/Contract.b73e010b8bc9c5f5c3f829a36b345280.svg";
export { ForwardRef as ReactComponent };